import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React from 'react';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import noop from '../../../utils/noop';
const UserCoreBadge = ({ corePackage , size , biData , className , openUserSymbolPopup =false , pushUserSymbolsPopup =noop  })=>{
    if (openUserSymbolPopup) {
        const biEventData = _object_spread_props(_object_spread({}, biData), {
            symbol: corePackage,
            evid: BiEventType.USER_SYMBOL_CLICK
        });
        const spanProps = {
            className
        };
        const onClick = (ev)=>{
            ev.preventDefault();
            // Only open the popup if we're not in an iframe
            if (window.self === window.top) {
                pushUserSymbolsPopup();
            }
        };
        return /*#__PURE__*/ React.createElement(BiSpan, _extends({}, spanProps, {
            // Role = "img" here to allow aria-label to exist on
            // this element without lighthouse throwing a fit
            role: "img",
            biData: biEventData,
            onClick: onClick,
            stopPropagation: true
        }), /*#__PURE__*/ React.createElement(CoreBadge, {
            corePackage: corePackage,
            size: size,
            className: className
        }));
    }
    return /*#__PURE__*/ React.createElement(CoreBadge, {
        corePackage: corePackage,
        size: size,
        className: className
    });
};
UserCoreBadge.displayName = 'UserCoreBadge';
export default UserCoreBadge;
